import {
  ChangeDetectionStrategy,
  Component,
  inject,
  input,
} from '@angular/core';
import { MatIconButton } from '@angular/material/button';
import { MatIcon } from '@angular/material/icon';
import { ToastService } from '@lassi/webapp-shared';

@Component({
  selector: 'lib-copy-link',
  standalone: true,
  imports: [MatIconButton, MatIcon],
  template: `
    <span class="link mat-body-small">{{ link() }}</span>
    <button
      color="primary"
      mat-icon-button
      class="copy"
      (click)="handleCopyToClipboard()"
    >
      <mat-icon> content_copy </mat-icon>
    </button>
  `,
  styles: `
    @use '@angular/material' as mat;
    @use 'theme' as theme;

    :host {
      display: flex;
      flex-wrap: nowrap;
      align-items: center;
      justify-content: space-between;
      padding: 0.25rem 0.5rem;
      border: 1px solid mat.get-theme-color(theme.$light-theme, outline-variant);
      border-radius: 0.25rem;

      .copy {
        flex-shrink: 0;
      }

      .link {
        flex-grow: 1;
        min-width: 0;
        text-overflow: ellipsis;
        overflow: hidden;
        white-space: nowrap;
      }
    }
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class CopyLinkComponent {
  link = input.required<string>();

  private readonly toastService = inject(ToastService);

  handleCopyToClipboard() {
    navigator.clipboard.writeText(this.link());
    this.toastService.showSuccessMessage('Link copied to clipboard');
  }
}
